import React, { useEffect } from 'react'
import { showError, showSuccess } from '../../stores/alert/slice.alert'
import firebase from 'firebase'
import { useDispatch, useSelector } from 'react-redux'
import { vapidKey } from '../../constants/firebase'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { pathKeys } from '../../constants'
import { accountApi } from '../../api/accountApi'
import { selectUser } from '../App/AppSelectors'

const NotiPermission = () => {
  const messaging = firebase.messaging()

  const history = useHistory()

  const user = useSelector(selectUser)

  const dispatch = useDispatch()

  const requestForToken = () => {
    return messaging
      .getToken(messaging, {
        vapidKey: vapidKey,
      })
      .then((currentToken) => {
        return currentToken
      })
  }

  function getUserIdFromURL() {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    return params.get('userId')
  }

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then((registration) => {
          return requestForToken()
        })
        .then((notiToken) => {
          const userId = getUserIdFromURL()

          if (!userId) return

          const payload = {
            userId,
            token: notiToken,
          }

          return accountApi.updateNotiPermissionToken(payload)
        })
        .then((res) => {
          dispatch(showSuccess('Get Notification Permision Successfully'))

          history.push(pathKeys.HOME)
        })
        .catch((error) => {
          if (
            error.message ===
            "Failed to execute 'subscribe' on 'PushManager': Subscription failed - no active Service Worker"
          ) {
            window.location.reload()
          }
          console.error('Service Worker registration failed:', error)

          dispatch(showError('Cannot Get Notification Permision Successfully'))
        })
    }
  }, [])

  return <></>
}

export default NotiPermission
